module.exports = __webpack_public_path__ + "img/liquid.27407160.jpg";